/** @jsx React.DOM */

var React = require('react');

var AddRemoveDatum = React.createClass({displayName: 'AddRemoveDatum',
  render: function() {
    return (
      React.DOM.p(null, 
        'Data points: ', 
        React.DOM.a({href: "#", onClick: this.handleAdd}, "Add"), 
        React.DOM.span(null, " - "), 
        React.DOM.a({href: "#", onClick: this.handleRemove}, "Remove")
      )
    );
  },

  handleAdd: function(e) {
    e.preventDefault();
    var domain = this.props.appState.domain.x;
    this.props.setAppState({
      data: this.props.addDatum(domain),
      // Disable animation
      prevDomain: null
    });
  },

  handleRemove: function(e) {
    e.preventDefault();
    var domain = this.props.appState.domain.x;
    this.props.setAppState({
      data: this.props.removeDatum(domain),
      prevDomain: null
    });
  }
});

module.exports = AddRemoveDatum;



/*****************
 ** WEBPACK FOOTER
 ** ./src/AddRemoveDatum.js
 ** module id = 7
 ** module chunks = 0
 **/